// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6.76855 11.8658L10.2327 9.86584L9.23266 8.13379L5.76855 10.1338L6.76855 11.8658ZM18.2327 10.1338L14.7686 8.13379L13.7686 9.86584L17.2327 11.8658L18.2327 10.1338ZM11.9998 12.9998C10.1479 12.9998 8.53238 14.0072 7.66936 15.4991L7.16864 16.3647L8.89985 17.3661L9.40058 16.5005C9.9208 15.6012 10.8907 14.9998 11.9998 14.9998C13.109 14.9998 14.0789 15.6012 14.5991 16.5005L15.0998 17.3661L16.831 16.3647L16.3303 15.4991C15.4673 14.0072 13.8518 12.9998 11.9998 12.9998Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-depressed-filled')
export default class DepressedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'depressed-filled',
    }
  }
}
